import { ref, watch, type Ref } from 'vue'
import type { RoutePlan } from '@gpx-spa/geo-domain'
import type { LineBufferGeometryCache } from '@gpx-spa/geo-adapters'
import { defaultSelectedByPathId } from '@/components/shipment/form/utils/shipment-form-route-composer-snapshot'

export function useShipmentFormSelectedPaths(
  routePlan: Ref<RoutePlan | null>,
  geoCache: LineBufferGeometryCache
) {
  const selectedByPathId = ref<Record<string, boolean>>({})

  watch(
    routePlan,
    (plan) => {
      geoCache.clear()
      selectedByPathId.value = defaultSelectedByPathId(plan)
    },
    { immediate: true }
  )

  return { selectedByPathId }
}
